// @mui
import { Box, Card, Paper, Typography, CardHeader, CardContent, CardProps } from '@mui/material';
// utils
import { fShortenNumber } from '../../../../utils/formatNumber';

import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

// ----------------------------------------------------------------------

interface Props extends CardProps {
  title?: string;
  subheader?: string;
  list?: {
    id:number;
    key: string;
    value: number;
    // icon: React.ReactElement;
  }[];
}

export default function ContractCategorized({ title, subheader, list, ...other }: Props) {
  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />

      <CardContent>
        <Box
          sx={{
            display: 'grid',
            gap: 2,
            gridTemplateColumns: 'repeat(2, 1fr)',
          }}
        >
          {list?.map((site) => (
            <Paper key={site.key} variant="outlined" sx={{ py: 2.5, textAlign: 'center' }}>
                <Box sx={{ mb: 0.5 }}><AttachMoneyIcon sx={{ fontSize: 50, color: 'green' }} /></Box>
              

              <Typography variant="h6">{fShortenNumber(site.value)}</Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {site.key}
              </Typography>
            </Paper>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}
